import { useDroppable } from "@dnd-kit/core"
import { KanbanItem } from "./KanbanItem"
import backgroundImage from "../../Utils/assets/img/leads_no_data_found.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { useVirtualizer } from "@tanstack/react-virtual"
import { useRef } from "react"

export const KanbanColumn = ({
  id,
  title,
  items,
  onAddClick,
  updatingLeads = [],
  onEditLead,
  // onFollowUpLead,
  onDeleteLead,
  onOpenLeadDetails,
  stageColor,
  mainGrant,
  followupGrant,
  highlightId,
  module_name,
  pipeline_id
}) => {
  // Kanban column component for displaying leads in a stage
  const { setNodeRef, isOver } = useDroppable({ id })
  const count = items?.length || 0

  // the ref given to the div responsible for scrolling the kanbanitems... 
  const scrollRef = useRef(null)

  const totalBudget = items?.reduce((sum, item) => {
    try {
      const productService = JSON.parse(item.product_services)
      const individualBudget = productService.reduce((acc, curr) => parseFloat(acc) + parseFloat(curr.budget), 0)
      const total = sum + individualBudget
      return total
    } catch (error) {
      return sum
    }
  }, 0);

  const formattedTotalBudget = totalBudget.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });


  const virtualizer = useVirtualizer({
    count: items?.length,
    estimateSize: () => 144,
    getScrollElement: () => scrollRef.current
  })

  // the virtualitems will be responsible for rendering the number of items currently being displayed onto the screen
  const virtualItems = virtualizer.getVirtualItems();

  // Color selection logic
  const colorOptions = ["#ffffff", "#ffe8cd", "#e4e6f9", "#d8f8ff", "#cbffe8", "#f3f3f3", "#ffe0fd", "#ffe0e0"]
  // white, 
  const colorsDiv = ["#004aff61", '#ffc584', "#919aff", '#89eaff', '#74f4bd', '#dfdfdf', '#fca2f6', "#feb9b9",];
  // skin contrast, cyan contrast, light skin, grey contrast, pink contrast, light red contrast , ideal for white,purple
  const budgetColors = ["#003bb3", "#b56f2b", "#646fc7", "#429cac", "#3ca17c", "#a8a8a8", "#b66caf", "#bd7171"];
  // Function to select color from colorsDiv based on stageColor or other   criteria
  const getSelectedColor = () => {
    // Option 1: If stageColor is provided and exists in colorOptions, use corresponding colorsDiv color
    if (stageColor) {
      const colorIndex = colorOptions.indexOf(stageColor);
      if (colorIndex !== -1) {
        return { budgetPillColor: colorsDiv[colorIndex], budgeColor: budgetColors[colorIndex] };
      }
    }
    // Option 3: Fallback to first color
    return { budgetPillColor: colorsDiv[0], budgetColor: budgetColors[0] };
  }

  const { budgetPillColor, budgeColor } = getSelectedColor();

  return (
    <div className="kanbanMainDiv" style={{ width: "320px", height: "calc(100vh - 11rem)", }}>

      <div
        ref={setNodeRef}
        className="mb-0 h-100" style={{ minWidth: '19rem', maxWidth: '20rem', overflowX: "hidden" }}>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ padding: "11px 17px", background: "#fff", borderRadius: "4px", border: "1px solid #e3e3e3" }}
        >
          <div className="d-flex flex-column gap-1 ">
            <h4 style={{ margin: 0, color: "rgb(46 56 77)", fontSize: "16px", fontWeight: 600 }}>
              {title} - {count}
            </h4>
            <div className="d-flex align-items-center" style={{ fontSize: "0.833rem", color: budgeColor }}>
              <span>₹{formattedTotalBudget}</span>
            </div>
          </div>
          <button
            onClick={() => onAddClick(id)}
            className="plusIconsButtonKanban"
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
        <div
          ref={scrollRef}
          style={{
            overflowY: "auto",
            padding: "8px 0px",
            overflowX: "hidden",
            borderRadius: "0px",
            height: "calc(100% - 11%)",
          }}
        >
          <div className="position-relative" style={{ width: "100%", overflow: "hidden", height: `${virtualizer.getTotalSize()}px` }}>
            {virtualItems.map((vItem) => {
              // the virtual items variable give us certain props that we will be using here

              // the below will give the exact item data that will be displaying onto the screen 
              const data = items[vItem.index];

              return (
                <div
                  key={vItem.key}
                  className="position-absolute w-100"
                  style={{
                    transform: `translateY(${vItem.start}px)`,
                    height: `${vItem.size}px`,
                    left: 0,
                    top: 0,
                  }}>
                  <KanbanItem
                    key={data.lead_id}
                    item={data}
                    columnId={id}
                    isUpdating={updatingLeads.includes(data.lead_id)}
                    onEdit={onEditLead}
                    onDelete={onDeleteLead}
                    onOpenLeadDetails={onOpenLeadDetails}
                    stageColor={stageColor}
                    mainGrant={mainGrant}
                    followupGrant={followupGrant}
                    highlightId={highlightId}
                    budgetPillColor={budgetPillColor}
                    module_name={module_name}
                    pipeline_id={pipeline_id}
                  />
                </div>
              )
            })}
          </div>
          {items.length === 0 && (
            <div
              className="d-flex flex-column align-items-center justify-content-center h-100"
              style={{
                color: "#6c757d",
                padding: "16px",
                border: isOver ? "2px dashed #4da4ff" : "2px dashed #dee2e6",
                borderRadius: "4px",
                background: "#fff"
              }}
            >
              {isOver ? (
                "Drop lead here"
              ) : (
                <>
                  <img src={backgroundImage || "/placeholder.svg"} alt="" style={{ width: "70%" }} />

                  <p style={{ color: "#038fed", cursor: "pointer", textTransform: "capitalize" }} onClick={() => onAddClick(id)}>
                    <FontAwesomeIcon icon={faPlus} /> Add {module_name}
                  </p>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div >
  )
}
